import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const PhotoResult = React.lazy(() => import("./views/PhotoResults"));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Routes>
          <Route exact path="/" name="PhotoResult" element={<PhotoResult />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;
